import { Box } from '@mui/material';
import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA } from '../../util/constants';

const { RECAPTCHA_KEY_V2 } = RECAPTCHA;

/**
 * @name Recaptcha
 * @description Implements Google Recaptcha
 * @param {object} root0  - destructured object
 * @param {object} root0.recaptchaRef - Recaptcha reference
 * @param {Function} root0.setCaptchaV2 - Sets Recaptcha v2 value
 * @param {Function} root0.setDisableCTA - Enables / disables CTA
 * @returns {JSX.Element} Google Recaptcha
 */
const Recaptcha = ({ recaptchaRef, setCaptchaV2, setDisableCTA }) => {
  /**
   * @function handleOnChange
   * @description  Handles Recaptcha on change
   * @param {string} value - Recaptcha Value
   */
  const handleOnChange = value => {
    if (value) {
      setCaptchaV2({ login: value, account: value });
      setTimeout(() => {
        setDisableCTA(false);
      }, 1000);
    } else {
      setDisableCTA(true);
    }
  };

  return (
    <Box sx={{ mt: 4, mb: 2, display: 'flex', justifyContent: 'center' }}>
      <ReCAPTCHA
        ref={recaptchaRef}
        className={'reCaptchaRobot'}
        sitekey={RECAPTCHA_KEY_V2}
        render='explicit'
        onChange={handleOnChange}
      />
    </Box>
  );
};

Recaptcha.displayName = 'Recaptcha';
export default Recaptcha;
